import {themr} from '@friendsofreactjs/react-css-themr';

import identifiers from '../identifiers';
import Frame from './frame';

export default themr(identifiers.frame)(Frame);
